import { lazy, Suspense, useState } from 'react';
import { useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { Carregando, Estado } from '../../componentes/estados';
import { get } from '../../nucleo/api';
import { chaveFluxos, type Fluxo } from './tipos-fluxos';

/** O canvas (React Flow, dagre) só é baixado quando esta tela abre. */
const Canvas = lazy(() => import('./Canvas'));

/** U14 F1: o editor de uma automação de conversa (Automações > Automações > a automação). */
export function EditorFluxo() {
  const { id = '' } = useParams();
  const [geracao, setGeracao] = useState(0);
  const [foco, setFoco] = useState<'versoes' | null>(null);
  const q = useQuery({ queryKey: [...chaveFluxos, 'fluxo', id], queryFn: () => get<Fluxo>(`/automacoes/fluxos/${id}`), refetchOnWindowFocus: false, staleTime: Infinity, gcTime: 0 });
  // Review r65 (ROB-M4): `gcTime: 0`: reabrir a automação lê o rascunho do servidor (o salvamento automático não atualiza o cache).
  return (
    <Estado consulta={q}>
      {(f) => (
        <Suspense fallback={<Carregando />}>
          {/* O canvas lê o fluxo só ao montar; recarregar (conflito, versão restaurada) monta de novo com o rascunho do servidor. */}
          <Canvas
            key={`${f.id}:${geracao}`}
            fluxo={f}
            focoInicial={foco}
            aoRecarregar={async (f) => {
              await q.refetch();
              setFoco(f ?? null);
              setGeracao((g) => g + 1);
            }}
          />
        </Suspense>
      )}
    </Estado>
  );
}
